module.exports = __webpack_public_path__ + "img/ico-haimurubushi.25f04cd8.png";